import { produce } from "immer";
import {
  DELETE_ITEM_FAILURE,
  DELETE_ITEM_PENDING,
  DELETE_ITEM_SUCCESS,
  GET_ITEMS_FAILURE,
  GET_ITEMS_PENDING,
  GET_ITEMS_SUCCESS,
  ITEMS_CLOSE_ADD_MODAL,
  ITEMS_CLOSE_EDIT_MODAL,
  ITEMS_CLOSE_VIEW_MODAL,
  ITEMS_EDIT_MODAL_OPEN_AND_FETCH,
  ITEMS_MODAL_SET_ITEM,
  ITEMS_OPEN_ADD_MODAL,
  ITEMS_VIEW_MODAL_OPEN_AND_FETCH,
  ITEMS_VIEW_MODEL_START_FETCH,
  ITEM_EDIT_FAILURE,
  ITEM_EDIT_PENDING,
  ITEM_EDIT_SUCCESS,
  ITEM_SAVE_FAILURE,
  ITEM_SAVE_PENDING,
  ITEM_SAVE_SUCCESS,
} from "./constants";

const initialState = {
  isItemsLoading: false,
  items: [],
  error: null,
  isItemSaving: false,
  saveError: null,
  reloadItems: false,
  isViewModalOpen: false,
  isItemDeleting: false,
  deleteError: null,
  doOpen: true,
};
const ItemReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ITEMS_PENDING:
        draft.isItemsLoading = true;
        draft.isItemSaving = false;
        draft.reloadItems = false;
        break;
      case GET_ITEMS_SUCCESS:
        draft.items = action.payload;
        draft.isItemsLoading = false;
        break;
      case GET_ITEMS_FAILURE:
        draft.error = action.payload.error;
        draft.isItemsLoading = false;
        break;
      case ITEMS_OPEN_ADD_MODAL:
        draft.isAddModalOpen = true;
        draft.currentItem = {};
        draft.isItemsLoading = false;
        break;
      case ITEMS_CLOSE_ADD_MODAL:
        draft.isAddModalOpen = false;
        break;
      case ITEMS_VIEW_MODAL_OPEN_AND_FETCH:
        draft.isFetching = true;
        draft.isViewModalOpen = true;
        draft.isItemSaving = true;
        break;
      case ITEMS_MODAL_SET_ITEM:
        draft.isFetching = false;
        draft.currentItem = action.payload;
        draft.isItemSaving = false;
        break;
      case ITEMS_CLOSE_VIEW_MODAL:
        draft.isItemsLoading = false;
        draft.isViewModalOpen = false;
        break;
      case ITEMS_EDIT_MODAL_OPEN_AND_FETCH:
        draft.isEditing = true;
        draft.isItemSaving = true;
        draft.isFetching = true;
        draft.isEditModalOpen = true;
        break;
      case ITEMS_VIEW_MODEL_START_FETCH:
        draft.isFetching = true;
        draft.isViewModalOpen = true;
        draft.isItemsLoading = false;
        break;

      //Save Items
      case ITEM_SAVE_PENDING:
        draft.isItemSaving = true;
        draft.saveError = null;
        break;
      case ITEM_SAVE_SUCCESS:
        draft.isItemSaving = false;
        draft.message = action.payload.message;
        draft.saveError = null;
        draft.reloadItems = true;
        draft.isEditing = false;
        draft.isFetching = false;
        draft.isEditModalOpen = false;
        draft.isAddModalOpen = false;
        break;
      case ITEM_SAVE_FAILURE:
        draft.isItemSaving = false;
        draft.saveError = action.payload.error;
        draft.isEditing = false;
        draft.isFetching = false;
        draft.isEditModalOpen = false;
        break;
      case ITEMS_CLOSE_EDIT_MODAL:
        draft.isEditing = false;
        draft.isEditModalOpen = false;
        break;

      // Edit Items
      case ITEM_EDIT_PENDING:
        draft.isItemSaving = true;
        draft.saveError = null;
        break;
      case ITEM_EDIT_SUCCESS:
        draft.isItemSaving = false;
        draft.message = action.payload.message;
        draft.saveError = null;
        draft.reloadItems = true;
        draft.isEditing = false;
        draft.isFetching = false;
        draft.isEditModalOpen = false;
        draft.isAddModalOpen = false;
        break;
      case ITEM_EDIT_FAILURE:
        draft.isItemSaving = false;
        draft.saveError = action.payload.error;
        draft.isEditing = false;
        draft.isFetching = false;
        draft.isEditModalOpen = false;
        break;

      // Delete Items
      case DELETE_ITEM_PENDING:
        draft.isItemDeleting = action.payload.isUserDeleting;
        draft.deleteError = null;
        draft.doOpen = true;
        break;
      case DELETE_ITEM_SUCCESS:
        draft.isItemDeleting = false;
        draft.message = action.payload.message;
        draft.deleteError = null;
        draft.doOpen = false;
        draft.reloadItems = true;
        break;
      case DELETE_ITEM_FAILURE:
        draft.isItemDeleting = false;
        draft.deleteError = action.payload.error;
        draft.doOpen = false;
        break;
      default:
        return state;
    }
  });
};
export default ItemReducer;
